const RADIUS = 100;

const WaterLevelSkeleton = () => {
    return (
        <div className="text-center">
            <div className="my-4 mx-auto loading-skeleton h-7 w-28 rounded-md" />
            <div
                className="relative mx-auto rounded-full loading-skeleton"
                style={{ width: RADIUS * 2, height: RADIUS * 2 }}
            >
                {/* <div className="absolute inset-0 flex items-center justify-center">
                    <div className="h-8 w-24 rounded-md bg-gray-300 animate-pulse" />
                </div> */}
            </div>
        </div>
    );
};

export default WaterLevelSkeleton;
